var _style, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlove01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{fill:#fff}.st1{fill:none;stroke:#231f20;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1474.3 930.6l-18.4 169.6c-3.4 31.1-14.3 61-31.7 87-58 86.4-191.6 292.9-196.1 369.2V1703h-84.5l31.5-121.7-316-91.1-148.2 66-.3.1-211-596.3s-50.8-214 41-286.2c0 0 11.7-230.4 144.5-261.7 0 0 31.2-173.6 160.1-195.2 0 0 33.2 11.6 27.3 81.9-5.9 70.3-31.2 251.9-31.2 251.9s46.9 210.9 58.6 216.8c8.7 4.4 21.8-124.4 27.9-190.5 2.4-25.5 8.6-50.4 18.5-74l82.8-196.4s30.9-41 79.8-23.4 52.7 72.2 41 105.5c-11.7 33.2-66.4 478.4-13.7 556.5 52.7 78.1 111.3 58.9 132.8 14.8 21.5-44.1 60.5-253 60.5-253s16.2-55.2 65.2-33.7c20 8.8 35 25.9 41.7 46.7l24.1 74.8c14.1 43.8 18.8 90.1 13.8 135.8z",
    id: "Layer_7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M859 1490.3l-148.2 66v146.8h432.7l31.5-121.7-316-91.1zm0 0l-148.2 66v146.8h432.7l31.5-121.7-316-91.1z",
    id: "Layer_8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STROKES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M499.6 960s-50.8-214 41-286.2c0 0 11.7-230.4 144.5-261.7 0 0 31.2-173.6 160.1-195.2 0 0 33.2 11.6 27.3 81.9-5.9 70.3-31.2 251.9-31.2 251.9s46.9 210.9 58.6 216.8c8.7 4.4 21.8-124.4 27.9-190.5 2.4-25.5 8.6-50.4 18.5-74l82.8-196.4s30.9-41 79.8-23.4 52.7 72.2 41 105.5c-11.7 33.2-66.4 478.4-13.7 556.5 52.7 78.1 111.3 58.9 132.8 14.8 21.5-44.1 60.5-253 60.5-253s16.2-55.2 65.2-33.7c20 8.8 35 25.9 41.7 46.7l24 74.8c14.1 43.8 18.8 90.1 13.8 135.8l-18.5 169.6c-3.4 31.1-14.3 61-31.7 87-58 86.4-191.5 292.9-196.1 369.2V1703h-84.5l31.5-121.7-316-91.1-148.5 66.1L499.6 960"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M710.8 1556.3V1703h432.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M685.1 412.1l-14.4 167c-2.1 23.8-.6 47.8 4.2 71.1l35.9 173.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.6 673.8l48.2 190.7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlove01);
export default __webpack_public_path__ + "static/media/glove-01.a958c5971f5b67ee317435c79a63bf34.svg";
export { ForwardRef as ReactComponent };